import * as angular from "angular";
import {IController} from "angular";
import {Reminder} from "../../models/reminder.model";
import {ReminderSettings} from "../../../site-preferences/models/reminder-settings.model";

export class DocumentEditCtrl implements IController {
  document: Reminder
  documentSettings: ReminderSettings
  isLoading: boolean;
  permissionUpdate: string;
  permissionDelete: string;
  isSelected: boolean;
  pattern: string;
  onUpload: Function;
  onUpdate: Function;
  onDeleted: Function;
  onSelect: Function;

  uploadDocument($files) {
    this.onUpload({$files: $files, documentSettingsId: this.documentSettings.id});
  }

  updateDocument($files) {
    this.onUpdate({$files: $files, documentSettingsId: this.documentSettings.id});
  }

}

angular
  .module('bringoz.admin.commons')
  .component('documentEdit', {
    bindings: {
      document: '<?',
      documentSettings: '<',
      isLoading: '<?',
      permissionUpdate: '<?',
      permissionDelete: '<?',
      isSelected:'<?',
      pattern: '@?',
      onUpload: '&',
      onUpdate: '&',
      onDeleted: '&',
      onSelect: '&'
    },
    template: require('./document-edit.html').default,
    controller: DocumentEditCtrl
  });
